/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Faq_A9Inputs */

const en_fc_home_faq_a9 = /** @type {(inputs: Fc_Home_Faq_A9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only a few so far. Speech to text is optional and off by default. Every editing action is also exposed as a command, so you can drive FilmCraft from scripts or connect AI agents through its MCP server.`)
};

/**
* | output |
* | --- |
* | "Only a few so far. Speech to text is optional and off by default. Every editing action is also exposed as a command, so you can drive FilmCraft from scripts ..." |
*
* @param {Fc_Home_Faq_A9Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_faq_a9 = /** @type {((inputs?: Fc_Home_Faq_A9Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Faq_A9Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_faq_a9(inputs)
});
export { fc_home_faq_a9 as "fc.home.faq.a9" }